import horizontalBarChartConvertor from './horizontalBarChartConvertor';
import horizontalLineChartConvertor from './horizontalLineChartConvertor';
import verticalBarChartConvertor from './verticalBarChartConvertor';
import priorityMatrixConvertor from './priorityMatrixConvertor';
import textConvertor from './textConvertor';
import tableConvertor from './tableConvertor';

export default {
  text: (node) => {
    return textConvertor(node.content, node.meta);
  },
  heading: (node) => {
    const content = textConvertor(node.content, node.meta);
    if (!content.style) content.style = `heading-${node.meta.level}`;
    return content;
  },
  table: tableConvertor,
  horizontalBarChart: horizontalBarChartConvertor,
  horizontalLineChart: horizontalLineChartConvertor,
  verticalBarChart: verticalBarChartConvertor,
  priorityMatrix: priorityMatrixConvertor,
  textThemeTable: tableConvertor,
  outliersUL: tableConvertor,
};
